<p class="logos">
  <img class="logos__rf" src="/assets/images/logo_rf.svg" alt="Logo République Française" />

  <img
    class="logos__france-relance"
    src="/assets/images/logo1j1s-france-relance.svg"
    alt="Logo 1 jeune 1 solution et France Relance"
  />
</p>
